<script lang="ts" module>
    export const route = "/workbench/:caseId";
</script>

<script lang="ts">
    import { notNullOrDie } from "@repo/utils";
    import { getClient } from "../lib/utils.js";
    import ErrorMessage from "../lib/components/common/error-message.svelte";
    import CaseView from "../lib/components/case-view.svelte";
    import { setBreadcrumbs } from "../lib/components/breadcrumbs.svelte";
    import { resolve, useRoute } from "../lib/route.svelte.js";
    import Sidebar from "../lib/components/sidebar/sidebar.svelte";
    import { m } from "../lib/messages.svelte.js";

    const route = useRoute();
    const caseId = $derived(notNullOrDie(route.current).params["caseId"] as string);
    function updateBreadcrumbs(title: string) {
        setBreadcrumbs([
            { title: m["workbench_"](), href: resolve("/workbench") },
            { title, href: resolve("/workbench/:caseId", { caseId }) },
        ]);
    }
    updateBreadcrumbs("");
    const promise = $derived(
        getClient({ fetch })["Get Case view"]({
            params: { caseId },
        }),
    );
</script>

<Sidebar>
    {#await promise then data}
        <div class="flex h-full grow overflow-x-hidden">
            <div class="grow overflow-x-hidden border-r">
                <CaseView
                    threadId={data.threadId}
                    transactionId={data.transactionId}
                    workflowId={data.workflowId}
                    processingId={data.processingId}
                    onThread={t => {
                        updateBreadcrumbs(t.messages[0]?.subject ?? "");
                    }}
                />
            </div>
        </div>
    {:catch e}
        <ErrorMessage {e} />
    {/await}
</Sidebar>
